import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import {
  CleanContentful,
  CleanedContentfulImageProps,
} from '@stadionhq-v3/clean-contentful';
import { GalleryEmbedProps } from '@stadionhq-v3/base-ui';
import { Gallery } from '@graphql/__generated__/graphql';
import { Translations } from '@lib/dictionary-keys/__generated__';

const galleryEmbedTransform = (
  gallery: CleanContentful<Gallery> & {
    images?: CleanedContentfulImageProps[];
  },
  dictionary: Pick<Translations['common']['action'], 'previous' | 'next'>
): GalleryEmbedProps => {
  const {
    images,
    galleryTitle,
    subTitle,
  }: {
    images?: CleanedContentfulImageProps[];
    galleryTitle?: string | undefined;
    subTitle?: string | undefined;
  } = gallery;

  return {
    galleryTitle: galleryTitle || '',
    subTitle: subTitle || '',
    gallery:
      images &&
      images?.map((image) => (
        <ContentfulImage {...image} key={image.id || image.alt} />
      )),
    captions: images && (images.map((image) => image?.caption) as string[]),
    attributions:
      images && (images.map((image) => image?.attribution) as string[]),
    totalImages: images?.length,
    previousButton: { text: dictionary.previous },
    nextButton: { text: dictionary.next },
  };
};

export default galleryEmbedTransform;
